const app = angular.module('msi.shipments.skipShipment', [
  require('./skip-shipment.controller')
]);

app.component('ogSkipShipmentButton', require('./skip-shipment-button'));

module.exports = app.name;
